// protected-routes.tsx
import { Navigate, useLocation } from "react-router-dom";
import { AuthState } from "../auth/types";
import { useIsAuthenticated } from "../auth/auth-service";
import { useEffect, useState } from "react";
import { useAuthStore } from "../auth/store";

interface ProtectedRoutesProps {
  children: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({
  children,
}) => {
  const location = useLocation();
  // Renamed to avoid confusion with the actual token
  const params = new URLSearchParams(location.search);
  const callback = params.get("callback");
  const origin = params.get("origin");

  // Use a ref to track if the mutation has been initiated in the current render cycle

  const { checkAuth } = useIsAuthenticated();
  const { authState, setAuthState } = useAuthStore();

  useEffect(() => {
    checkAuth().then(setAuthState);
  }, []);

  if (authState === null) {
    // Loading or checking auth status
    return <div></div>;
  }

  if (authState === AuthState.Authenticated) {
    return <>{children}</>;
  } else if (authState === AuthState.Refreshing) {
    return (
      <Navigate to="/auth/0" state={{ isNavigatingInsideApplication: true }} />
    );
  } else {
    if (callback) {
      return <Navigate to={`/login?callback=${callback}&origin=${origin}`} />;
    }

    return (
      <Navigate
        to="/login"
        state={{ isNavigatingInsideApplication: true, lockAuthState: true }}
      />
    );
  }
};
